import React from 'react';
import PropTypes from 'prop-types';
import { AutoparkTransportForm } from '../transport-form';
import { TRANSPORT_TABLE_COLUMNS_NAMES } from '../../constants';
import { AutoparkTransportInfoTable } from '../transport-info-table';

export const AutoparkTransportModalContent = ({
	autoparkTransportInfo,
	isAutoparkTransportInfoLoading,
	isAutoparkTransportFormOpen,
}) => {
	return isAutoparkTransportFormOpen ? (
		<AutoparkTransportForm />
	) : (
		<AutoparkTransportInfoTable
			rows={autoparkTransportInfo}
			isTableDataLoading={isAutoparkTransportInfoLoading}
			columns={TRANSPORT_TABLE_COLUMNS_NAMES}
		/>
	);
};

AutoparkTransportModalContent.propTypes = {
	autoparkTransportInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]).isRequired,
			group: PropTypes.string,
		}),
	),
	isAutoparkTransportInfoLoading: PropTypes.bool.isRequired,
	isAutoparkTransportFormOpen: PropTypes.bool.isRequired,
};
